// Gerado por `pnpm modules:sync` a partir dos module.json (ADR 0123). Não edite à mão.
import type { WebModule } from './web-module.ts';
import { webModule as customers } from './customers/module.tsx';
import customersEn from './customers/i18n/en.json';
import customersPtBR from './customers/i18n/pt-BR.json';
import { webModule as orders } from './orders/module.tsx';
import ordersEn from './orders/i18n/en.json';
import ordersPtBR from './orders/i18n/pt-BR.json';
import { webModule as suppliers } from './suppliers/module.tsx';
import suppliersEn from './suppliers/i18n/en.json';
import suppliersPtBR from './suppliers/i18n/pt-BR.json';
import { webModule as purchases } from './purchases/module.tsx';
import purchasesEn from './purchases/i18n/en.json';
import purchasesPtBR from './purchases/i18n/pt-BR.json';

export const WEB_MODULES: readonly WebModule[] = [
  customers,
  orders,
  suppliers,
  purchases,
];

/** Os textos de cada módulo, debaixo da chave com o id dele (`t('<id>.…')`). */
export const MODULE_TRANSLATIONS = {
  'pt-BR': {
    customers: customersPtBR,
    orders: ordersPtBR,
    suppliers: suppliersPtBR,
    purchases: purchasesPtBR,
  },
  en: {
    customers: customersEn,
    orders: ordersEn,
    suppliers: suppliersEn,
    purchases: purchasesEn,
  },
};
